import './gb-collection-item.tag.html';
import './gb-collection-dropdown-item.tag.html';
import '../badge/gb-badge.tag.html';
import '../list/gb-list.tag.html';
import '../select/gb-select.tag.html';
import { Collections } from './gb-collections';
riot.tag2('gb-collections', '<yield> <gb-list class="gb-collections {_style}" items="{collections}" if="{!_config.dropdown}" scope="gb-collections" inline> <gb-collection-item></gb-collection-item> </gb-list> <gb-select if="{_config.dropdown}" scope="gb-collections"> <gb-custom-select> <gb-collection-dropdown-item></gb-collection-dropdown-item> </gb-custom-select> </gb-select> </yield>', '', '', function(opts) {
    this._mixin(Collections);
});



/** WEBPACK FOOTER **
 ** ./src/tags/collections/gb-collections.tag.html
 **/